export default "__VITE_ASSET__$FwyCh45__"